import { AnimatePresence, motion } from "framer-motion";
import { MdCheck } from "react-icons/md";
import TextLoadingAnimation from "utils/TextLoadingAnimation";

interface ProcessingDataAnimationProps {
  finishedValidation: boolean;
  processingText: string;
  finishedText?: string;
}

const ProcessingDataAnimation: React.FC<ProcessingDataAnimationProps> = ({
  finishedValidation,
  processingText,
  finishedText = "",
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9 }}
      transition={{ duration: 0.1, ease: "easeOut" }}
      className="h-[590px] p-8 bg-white flex-col justify-center items-center gap-[34px] inline-flex"
    >
      <AnimatePresence mode="wait">
        {!finishedValidation ? (
          <motion.div
            key="loading"
            className="p-4 rounded-[100px] border-2 border-neutral-50 justify-start items-start gap-2 flex"
            initial={{ opacity: 0 }}
            animate={{ opacity: [0, 1, 1, 0] }}
            exit={{ opacity: 0, scale: 0.8, transition: { duration: 0.3 } }}
            transition={{
              duration: 3,
              times: [0, 0.04, 0.96, 1],
              ease: "easeInOut",
              repeat: Infinity,
            }}
          >
            <div className="w-8 h-8 relative">
              <MdCheck className="w-full h-full fill-neutral-50" />
            </div>
          </motion.div>
        ) : (
          <motion.div
            key="success"
            className="p-4 rounded-[100px] border-2 border-success-500 justify-start items-start gap-2 flex"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.15, ease: "easeInOut" }}
          >
            <div className="w-8 h-8 relative">
              <MdCheck className="w-full h-full fill-success-500" />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <div className="w-[373px] justify-start items-start gap-2 inline-flex">
        <div className="grow shrink basis-0 text-center text-neutral-700 text-sm font-semibold font-sans leading-[17px] select-none">
          {finishedValidation && finishedText ? finishedText : processingText}
          {!finishedValidation && <TextLoadingAnimation />}
        </div>
      </div>
    </motion.div>
  );
};

export default ProcessingDataAnimation;
